import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchGenders,
  updateGender as updateGenderService,
} from "./gender.service";
import { GenderData, UpdateGenderRequest } from "./gender.types";
import { handleApiError } from "@/app/utils/handleApiError";
import { RejectValueType } from "../redux/redux.types";

export const getGenders = createAsyncThunk<GenderData, void, RejectValueType>(
  "gender/getGenders",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchGenders();
      return response.data;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
);

export const updateGender = createAsyncThunk<
  null,
  UpdateGenderRequest,
  RejectValueType
>("gender/updateGender", async (data, { rejectWithValue }) => {
  try {
    await updateGenderService(data);
    return null;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});
